import { dimLabel, isPlaceholderDim } from '../dim.js';

/** Pulse tooltip extras to omit on cucumber lines. */
export const hideLineDims = ['storage', 'environment'];

export function varietyLabel(variety) {
  const label = dimLabel(variety);
  if (/^long english$/i.test(label)) return 'L.E.';
  return label;
}

function stripSizeWord(token) {
  return String(token || '').replace(/\s+size$/i, '').trim();
}

/**
 * Bushel: size STRING (item_size Large/Medium/Small/Irregular), never size_group.
 * When size_granularity is set (cartons): extra_info or granularity (24s/36s).
 */
function liveSizeTok(token) {
  const t = stripSizeWord(token);
  if (!t) return '';
  if (t.toLowerCase() === 'not classified') return '';
  return t;
}

export function sizeTokens(rec) {
  const g = liveSizeTok(dimLabel(rec?.sizeGroup));
  const s = liveSizeTok(dimLabel(rec?.size));
  const gran = liveSizeTok(dimLabel(rec?.sizeGranularity));
  const extra = liveSizeTok(dimLabel(rec?.sizeExtraInfo));
  const pkg = String(rec?.package || '');
  const variety = String(rec?.variety || '');
  let toks;
  if (/pickle/i.test(variety)) toks = gran ? [gran] : (s ? [s] : []);
  else if (/bushel/i.test(pkg)) toks = g ? [g] : (s ? [s] : []);
  else if (gran) toks = [gran];
  else if (extra) toks = [extra];
  else if (/\d/.test(s)) toks = [s];
  else toks = s ? [s] : (g ? [g] : []);
  if (/1\s*1\/9/i.test(pkg) && /bushel/i.test(pkg) && !toks.includes('1 1/9')) toks.push('1 1/9');
  return toks.filter(Boolean);
}

/** Lake remap already Premium/Good/Fair. Drop the redundant " Quality" word on the line. */
export function qualityLabel(quality) {
  return dimLabel(quality).replace(/\s+quality$/i, '').trim();
}

export const dropVarietyIfSameAsEnv = true;

/** Quality last so foldLeaves nests Premium/Good/Fair under size (+ appearance). */
export const extrasDimOrder = ['condition', 'appearance', 'properties', 'quality'];

/** Terminal serving uses Field Cucumbers; FOB uses Field. Same env heading. */
export function varietySameAsEnv(variety, env) {
  const v = String(variety || '').trim().toLowerCase();
  const e = String(env || '').trim().toLowerCase();
  if (!v || !e) return false;
  if (v === e) return true;
  const fieldEnv = e === 'field' || e === 'open field';
  if (fieldEnv && (v === 'field' || v === 'field cucumbers' || v === 'slicers/field')) return true;
  return false;
}

function envSectionLabel(env) {
  const e = dimLabel(env);
  if (/^(gh|greenhouse)$/i.test(e)) return 'Greenhouse';
  return e || 'Other';
}

function envRank(label) {
  const e = String(label || '').trim().toLowerCase();
  if (e === 'greenhouse' || e === 'gh') return 0;
  if (e === 'field') return 1;
  if (e === 'other') return 3;
  return 2;
}

/** District is outer (caller). Inner groups: Greenhouse then Field. */
export function sectionLeaves(leaves, foldLeaves, sortBlocksByHigh) {
  const envMap = new Map();
  for (const leaf of leaves) {
    const env = envSectionLabel(leaf.environment);
    if (!envMap.has(env)) envMap.set(env, []);
    envMap.get(env).push(leaf);
  }
  const envKeys = [...envMap.keys()].sort((a, b) => {
    const rank = envRank(a) - envRank(b);
    if (rank) return rank;
    const ha = Math.max(...envMap.get(a).map((l) => (l.high == null ? -Infinity : l.high)));
    const hb = Math.max(...envMap.get(b).map((l) => (l.high == null ? -Infinity : l.high)));
    return hb - ha;
  });
  return envKeys.map((env) => ({
    heading: isPlaceholderDim(env) ? 'Other' : env,
    strong: true,
    rows: [],
    blocks: sortBlocksByHigh(foldLeaves(envMap.get(env))),
  }));
}
